import BreadcrumbsMixin from '../../Mixins/BreadcrumbsMixin';
import UserComponentMixin from '../../Mixins/UserComponentMixin';

export default {
  mixins: [BreadcrumbsMixin, UserComponentMixin],

  methods: {
    navigateToIndexRoute () {
      this.$router.push({
        name: 'Edit User',
        params: {
          id: this.user.id
        }
      });
    },

    navigateToEditRoute (response) {
      this.$router.push({
        name: 'Edit User Mobile Number',
        params: {
          userId: this.user.id,
          id: response.user_mobile_number.id
        }
      });
    }
  }
};
